<template>
    <div>
        <public-menu></public-menu>
        <public-article-detail></public-article-detail>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Public_article_detail from "@/components/article/article_detail"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-article-detail': Public_article_detail,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');

</style>


// WEBPACK FOOTER //
// src/views/article/article_detail.vue